// What a page calls a show's platform. Stored names are left as the sources
// gave them; they feed generation.
// - getDisplayPlatforms: for cards and meta lines readers see. The service
//   first, then the broadcaster ("Crunchyroll · TBS").
// - getDisplayNetwork: the original network, then the listing source. It stays
//   for search-facing text (show titles, RSS, shows-like payload), which is
//   frozen until the findability review.
const DISPLAY_NAMES = { 5: "Channel 5" };
const SERVICE_NAMES = {
  "AppleTV+": "Apple TV",
  MAX: "HBO Max",
  "Paramount Plus": "Paramount+",
  "Crunchyroll Premium": "Crunchyroll",
  "Tubi TV": "Tubi",
};

const clean = (value) => (typeof value === "string" ? value.trim() : "");

export function getDisplayNetwork(show) {
  const name = [
    ...(Array.isArray(show?.networks) ? show.networks : []),
    show?.sourceName,
    show?.omdbData?.network,
  ].map(clean).find(Boolean) || "";
  return DISPLAY_NAMES[name] || name;
}

export function getDisplayPlatforms(show) {
  const source = clean(show?.sourceName);
  const service = SERVICE_NAMES[source] || DISPLAY_NAMES[source] || source;
  const raw = [
    ...(Array.isArray(show?.networks) ? show.networks.slice(0, 1) : []),
    show?.omdbData?.network,
  ].map(clean).find(Boolean) || "";
  const broadcaster = DISPLAY_NAMES[raw] || raw;
  const a = service.toLowerCase();
  const b = broadcaster.toLowerCase();
  if (!service || a.startsWith(b) || b.startsWith(a)) return service || broadcaster;
  return `${service} · ${broadcaster}`;
}
